import { createPattern, escapeSelector } from '../utils';
import { ClassObjectType } from '../types';

// Pattern
export const pattern = createPattern('d-([a-z\-]+)(?:__([^!]+)){0,1}(\!){0,1}', {breakpoints: true});

// Resolver
export const rules = (props): ClassObjectType => {
    const [className, breakpoint, value, rawChildSelector, important] = props;
    // console.log(props);
    const selector = escapeSelector(className);
    const childSelector = escapeSelector(rawChildSelector, false);

    const rule = {
        [`${selector}${childSelector ? ` ${childSelector}` : ''}`]: {
            display: `${value}${important ? ' !important' : ''}`
        }
    };

    return {
        breakpoint,
        rule
    };
    
}

export default { pattern, rules };